import { useTranslation } from 'react-i18next';
import { FormTemplate, FormTemplateScopeNameEnum } from 'graphql-common';
import { UseBulkSelectResult } from '@lib/hooks/useTableItemsBulkSelect';
import { UseModalManagementResult } from './useModalManagement';
import { UseActionsResult } from './useActions';
import getTableTabs from './getTableTabs';
import getTableColumns from './getTableColumns';
import getTableActionsMenu from './getTableActionsMenu';
import getTableActionsForSelected from './getTableActionsForSelected';

type Args = {
  formTemplateScope: FormTemplateScopeNameEnum;
  isViewOnly: boolean;
  useActionsResult: UseActionsResult;
  useBulkSelectResult: UseBulkSelectResult<FormTemplate>;
  useModalManagementResult: UseModalManagementResult;
  totalFormTemplatesCount: number;
};

export default function useTableHelpers(args: Args) {
  const {
    formTemplateScope,
    isViewOnly,
    totalFormTemplatesCount,
    useActionsResult,
    useBulkSelectResult,
    useModalManagementResult,
  } = args;
  const {
    formTemplateCounter,
    onArchiveHandler,
    onCreateTaskHandler,
    onDestroyHandler,
    onDuplicateHandler,
    onEditHandler,
    onRestoreHandler,
    onViewHandler,
  } = useActionsResult;
  const { openDestroyModal, openArchiveModal } = useModalManagementResult;
  const { getSelectedItemsCount } = useBulkSelectResult;

  const { t } = useTranslation();

  const tableTabs = getTableTabs({ t, formTemplateCounter });
  const tableColumns = getTableColumns({
    formTemplateScope,
    t,
    onCreateTaskHandler,
    onRestoreHandler,
    isViewOnly,
  });
  const tableActionsMenu = getTableActionsMenu({
    onViewHandler,
    onEditHandler,
    onDestroyHandler,
    onDuplicateHandler,
    onArchiveHandler,
    isViewOnly,
    t,
  });
  const tableActionsForSelected = getTableActionsForSelected({
    formTemplateScope,
    onBulkArchive: openArchiveModal,
    onBulkDestroy: openDestroyModal,
    onBulkRestore: onRestoreHandler,
    isViewOnly,
    selectedItemsCount: getSelectedItemsCount(totalFormTemplatesCount),
    t,
  });

  return {
    tableColumns,
    tableActionsMenu,
    tableActionsForSelected,
    tableTabs,
  };
}
